/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tab_ContactsInputs */

const cs_clients_tab_contacts = /** @type {(inputs: Clients_Tab_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakty`)
};

const en_clients_tab_contacts = /** @type {(inputs: Clients_Tab_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts`)
};

/**
* | output |
* | --- |
* | "Contacts" |
*
* @param {Clients_Tab_ContactsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tab_contacts = /** @type {((inputs?: Clients_Tab_ContactsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tab_ContactsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tab_contacts(inputs)
	return cs_clients_tab_contacts(inputs)
});